import type {
  RoadSpeedLimitAlert,
  RoadSpeedLimitAlertAPI,
  StopIdleTimeAlert,
  StopIdleTimeAlertAPI,
  UserAlert,
  UserAlertAPI,
  VehicleSpeedLimitAlert,
  VehicleSpeedLimitAlertAPI,
} from './definitions';

import type { PageableContent, PageableContentAPI } from '@cobliteam/common-types';

import { SettingsType, toSeverity } from '../commons';

export const toUserAlert = (historyAPI: UserAlertAPI): UserAlert => {
  const commonFields = {
    id: historyAPI.id,
    vehicleId: historyAPI.vehicle_id,
    driverId: historyAPI.driver_id,
    vehicleGroupId: historyAPI.vehicle_group_id,
    type: historyAPI.type,
    processedAt: historyAPI.processed_at,
  };
  switch (historyAPI.type) {
    case SettingsType.ROAD_SPEED_LIMIT:
      const roadSpeedLimitAlert = historyAPI as RoadSpeedLimitAlertAPI;
      return {
        ...commonFields,
        durationInMillis: roadSpeedLimitAlert.duration_in_millis,
        speedLimitInKmH: roadSpeedLimitAlert.speed_limit_in_km_h,
        speedInKmH: roadSpeedLimitAlert.speed_in_km_h,
        severity: toSeverity(roadSpeedLimitAlert.severity),
      } as RoadSpeedLimitAlert;

    case SettingsType.VEHICLE_SPEED_LIMIT:
      const vehicleSpeedLimitAlert = historyAPI as VehicleSpeedLimitAlertAPI;
      return {
        ...commonFields,
        durationInMillis: vehicleSpeedLimitAlert.duration_in_millis,
        speedLimitInKmH: vehicleSpeedLimitAlert.speed_limit_in_km_h,
        speedInKmH: vehicleSpeedLimitAlert.speed_in_km_h,
      } as VehicleSpeedLimitAlert;

    case SettingsType.STOP_IDLE_TIME:
      const stopIdleTimeAlert = historyAPI as StopIdleTimeAlertAPI;
      return {
        ...commonFields,
        durationInMillis: stopIdleTimeAlert.duration_in_millis,
      } as StopIdleTimeAlert;
  }
};

export const toUserAlertPage = (page: PageableContentAPI<UserAlertAPI>): PageableContent<UserAlert> => ({
  content: page.content.map(toUserAlert),
  last: page.last,
  totalPages: page.total_pages,
  totalElements: page.total_elements,
  numberOfElements: page.number_of_elements,
  number: page.number,
  size: page.size,
  first: page.first,
  empty: page.empty,
});
